import React, {useMemo} from 'react';
import {useIsDesktop} from "@/hooks/useDevice";
import ParallaxSliderDesktop from "@/components/ParallaxSlider/Desktop";
import ParallaxSliderMobile from "@/components/ParallaxSlider/Mobile";
import {getLinkData} from "@/components/common/Links/utils";
import {IMAGE_FALLBACK} from "@/constants";

const EMPTY_SLIDE = {
	id: '',
	title: '',
	description: '',
	backgroundColor: {
		color: 'white'
	},
	thumbnail: {
		image: { ...IMAGE_FALLBACK }
	}
}

const ParallaxSlider = ({ data }) => {
	const isDesktop = useIsDesktop(false)
	const props = useMemo(() => {
		const id = data?.id || ''
		const header = data?.header || ''
		const buttonData = getLinkData(data?.button?.link)
		return {
			id,
			header,
			button: buttonData,
			slides: data?.slides || [EMPTY_SLIDE]
		}
	}, [data])

	return isDesktop ? <ParallaxSliderDesktop {...props} /> : <ParallaxSliderMobile {...props} />
};

export default ParallaxSlider;
